import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'crm/addresses';

export const ADDRESSES_ENDPOINTS = {
  createAddress: formatEndpoint('', namespace),
  retrieveAddresses: () => formatEndpoint('', namespace),
  updateAddress: formatEndpoint('', namespace),
};
